import React, { useState, useEffect, useCallback } from 'react';
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import EntryPopup from './components/EntryPopup';
import HeroSection from './components/HeroSection';
import USPStrip from './components/USPStrip';
import LunchDealBanner from './components/LunchDealBanner';
import MittagsmenueSection from './components/MittagsmenueSection';
import PizzaSection from './components/PizzaSection';
import BowlsSection from './components/BowlsSection';
import BaguettesWrapsSection from './components/BaguettesWrapsSection';
import BurgersSection from './components/BurgersSection';
import PastaCalzoneSection from './components/PastaCalzoneSection';
import SaladsSchnitzelSection from './components/SaladsSchnitzelSection';
import FingerfoodDrinksSection from './components/FingerfoodDrinksSection';
import AboutSection from './components/AboutSection';
import ReviewsSection from './components/ReviewsSection';
import DeliverySection from './components/DeliverySection';
import CateringSection from './components/CateringSection';
import ReservationSection from './components/ReservationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupTriggered, setPopupTriggered] = useState(false);

  // Callback triggered when HANSE typing completes
  const handleShowPopup = useCallback(() => {
    if (!popupTriggered) {
      setPopupTriggered(true);
      setShowPopup(true);
    }
  }, [popupTriggered]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Handle escape key for popup
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setShowPopup(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <LanguageProvider>
      <div className="App" data-testid="hanse-pizza-app">
        {/* Navigation */}
        <Navigation />

        {/* Entry Popup - triggered after HANSE typing completes */}
        {showPopup && <EntryPopup onClose={handleClosePopup} />}

        {/* Main Content */}
        <main>
          {/* Hero - passes callback to trigger popup after HANSE types */}
          <HeroSection onShowPopup={handleShowPopup} />

          {/* USP Strip */}
          <USPStrip />

          {/* Mittagessen / Lunch Specials */}
          <MittagsmenueSection />

          {/* Pizza Section */}
          <PizzaSection />

          {/* Bowls Section - Highlighted Star Section */}
          <BowlsSection />

          {/* Baguettes & Wraps */}
          <BaguettesWrapsSection />

          {/* Burgers */}
          <BurgersSection />

          {/* Pasta & Calzone */}
          <PastaCalzoneSection />

          {/* Salads & Schnitzel */}
          <SaladsSchnitzelSection />

          {/* Fingerfood & Drinks */}
          <FingerfoodDrinksSection />

          {/* About */}
          <AboutSection />

          {/* Reviews */}
          <ReviewsSection />

          {/* Delivery Platforms */}
          <DeliverySection />

          {/* Catering */}
          <CateringSection />

          {/* Table Reservation */}
          <ReservationSection />

          {/* Contact & Map */}
          <ContactSection />
        </main>

        {/* Footer */}
        <Footer />

        {/* Sticky Lunch Deal Banner - scrolls horizontally */}
        <LunchDealBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;
